module.exports = __webpack_public_path__ + "img/credit3.2be822cf.png";